<q9-icon-button
  class="sb-toolbar-actions"
  [matMenuTriggerFor]="menu"
  [icon]="'dialog-icon'"
  [matTooltip]="'TOOLBAR.COMMENTS_TT' | translate"
  matTooltipPosition="below"
  [count]="commentsCount"></q9-icon-button>
<div>
  <mat-menu #menu="matMenu" class="diagram-comments-container">
    <div class="diagram-comments-inner-container" (click)="$event.stopPropagation()">
      <div class="tabs-container">
        <q9-select
          [label]="'CORE.ATTACHMENTS.TYPE'"
          [ngModel]="selectedMode()"
          (selectionChange)="changeState($event)">
          <q9-option *ngFor="let option of selectOptions" [value]="option.value">
            {{ option.label | translate }}
          </q9-option>
        </q9-select>
      </div>
      <div class="tab-content">
        <q9-feedback
          *ngIf="matMenuTrigger.menuOpen"
          [feedbackConfig]="feedbackConfig()"
          (feedbackCountChange)="commentsCount = $event"></q9-feedback>
      </div>
    </div>
  </mat-menu>
</div>
